
const state = {
  headers: [],
  id: undefined,
  link_text: 'Manage Item',
  method: 'GET',
  status_id: undefined,
  title: '',
  url: '',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'url' },
]

export default state
